<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12 text-center">
      <div class="page-header" style="margin: auto; margin-top: 30px; margin-bottom: 50px; max-width: 500px; line-height: 1.5">
        <p>
          <label>Would you like stop receiving emails with the following report?</label>
        </p>
        <p>
          <label style="font-weight: bold">"{{unsubscribeObject?.reportName}}"</label>
        </p>
        <button mat-raised-button color="warn" [promiseBtn]="buttonUnsubscribePromise" (click)="unsubscribeConfirm()">Unsubscribe</button>
        <button mat-raised-button (click)="returnHome()" style="margin-left: 10px">Cancel</button>
      </div>
    </div>
  </div>
</div>
